import { useState } from "react";
import { Link, useParams } from "react-router";
import FollowButton from "../../components/follow-button/follow-button";
import { useAuthorBroadcasts } from "../../hooks/use-author-broadcasts";
import { useAuthorProfile } from "../../hooks/use-author-profile";
import { useCurrentUser } from "../../hooks/use-current-user";
import { authFetch } from "../../lib/auth-fetch";

const DEFAULT_BANNER = "#1a1a2e";

const formatDate = (iso: string | null) => {
	if (!iso) return "";
	return new Date(iso).toLocaleDateString(undefined, {
		day: "numeric",
		month: "short",
		year: "numeric",
	});
};

const AuthorProfile = () => {
	const { uid } = useParams<{ uid: string }>();
	const profile = useAuthorProfile(uid ?? null);
	const { live, history } = useAuthorBroadcasts(uid ?? null);
	const currentUser = useCurrentUser();
	const isOwner = !!currentUser && currentUser.uid === uid;
	const [deletingId, setDeletingId] = useState<string | null>(null);
	const [confirmId, setConfirmId] = useState<string | null>(null);

	if (!uid) return <div>Profile not found.</div>;

	return (
		<div>
			<div style={{ background: profile.bannerColor ?? DEFAULT_BANNER, padding: "2rem 1rem", color: "#fff" }}>
				<h1>{profile.name ?? "Anonymous author"}</h1>
				{profile.bio && <p>{profile.bio}</p>}
				<div>
					<span>{profile.followerCount} {profile.followerCount === 1 ? "follower" : "followers"}</span>
					{uid && <FollowButton authorId={uid} />}
				</div>
			</div>

			<div style={{ padding: "1rem" }}>
				<p><Link to="/">← Home</Link></p>

				{live.length > 0 && (
					<section>
						<h2>🔴 Live now</h2>
						{live.map((b) => (
							<div key={b.id}>
								<Link to={`/broadcast/${b.id}`}>
									<strong>{b.homeTeam} {b.homeScore} – {b.awayScore} {b.awayTeam}</strong>
								</Link>
							</div>
						))}
					</section>
				)}

				{history.length > 0 && (
					<section>
						<h2>Past broadcasts</h2>
						{history.map((b) => (
							<div key={b.id}>
								<Link to={`/broadcast/${b.id}`}>
									{b.homeTeam} {b.homeScore} – {b.awayScore} {b.awayTeam}
								</Link>
								{b.endedAt && <span> · {formatDate(b.endedAt)}</span>}
								{b.stats && (
									<span>
										{" · "}👁 {b.stats.totalViewers}
										{Object.entries(b.stats.reactionTotals).map(([emoji, count]) => (
											<span key={emoji}> {emoji} {count}</span>
										))}
									</span>
								)}
								{isOwner && (
									<>{" "}<Link to={`/broadcast/${b.id}/stats`}>Stats</Link></>
								)}
								{isOwner && confirmId === b.id ? (
									<span>
										{" "}
										<button type="button" disabled={deletingId === b.id} onClick={async () => {
											setDeletingId(b.id);
											await authFetch(`/api/broadcasts/${b.id}`, { method: "DELETE" });
											setDeletingId(null);
											setConfirmId(null);
										}}>Confirm delete</button>
										<button type="button" onClick={() => setConfirmId(null)}>Cancel</button>
									</span>
								) : isOwner && (
									<button type="button" onClick={() => setConfirmId(b.id)}>Delete</button>
								)}
							</div>
						))}
					</section>
				)}

				{live.length === 0 && history.length === 0 && (
					<p>No broadcasts yet.</p>
				)}
			</div>
		</div>
	);
};

export default AuthorProfile;
